import { parseISO8601 } from "../iso8601";
import {
  CellTextBoxDot,
  narrowCellsFrench,
  NumberAsPercent,
  NumberAsTwoDigits,
  safeString,
  safeZero,
  styles,
} from "../reportingHelpers";
import { View } from "@react-pdf/renderer";
import React from "react";

export const BoxScoreReportRow = ({
  row,
  index,
  isTotalsRow = false,
  intl,
  isTeamCoachRow,
  teamOrCoachRow,
  persons,
}) => {
  let rowMinutesText = "",
    parsedMinutes = {};

  parsedMinutes = parseISO8601(row.minutes);
  rowMinutesText =
    parsedMinutes.minutes.toString() +
    (":" + NumberAsTwoDigits({ value: parsedMinutes.seconds }));
  if (parsedMinutes.minutes === 0 && parsedMinutes.seconds === 0) {
    rowMinutesText = intl.formatMessage({
      id: "reports.boxscore.table.dnp",
      defaultMessage: "DNP",
    });
  }

  return (
    <View
      style={{
        ...styles.tableRowFrench,
        backgroundColor: "white",
      }}
    >
      {isTeamCoachRow ? (
        <React.Fragment>
          <CellTextBoxDot style={{ width: "5mm" }}></CellTextBoxDot>
          <CellTextBoxDot
            style={{
              textAlign: "left",
              paddingLeft: 2,
              width: "31.8mm",
              borderLeftWidth: 0,
            }}
          >
            {intl.formatMessage({
              id: "reports.boxscore.table.teamcoach",
              defaultMessage: "Team/Coach",
            })}
          </CellTextBoxDot>
          <CellTextBoxDot style={{ width: "105mm" }}></CellTextBoxDot>
          <CellTextBoxDot style={{ ...narrowCellsFrench }}>
            {safeZero(row, "fouls")}
          </CellTextBoxDot>
          <CellTextBoxDot style={narrowCellsFrench}>
            {safeZero(row, "foulsDrawn")}
          </CellTextBoxDot>
          <CellTextBoxDot style={{ width: "12mm" }}> </CellTextBoxDot>
          <CellTextBoxDot style={{ ...narrowCellsFrench }}>
            {safeZero(row, "reboundsTeamOffensive")}
          </CellTextBoxDot>
          <CellTextBoxDot style={{ ...narrowCellsFrench }}>
            {safeZero(row, "reboundsTeamDefensive")}
          </CellTextBoxDot>
          <CellTextBoxDot style={narrowCellsFrench}>
            {safeZero(row, "reboundsTeamTotal")}
          </CellTextBoxDot>

          <CellTextBoxDot style={{ ...narrowCellsFrench }}> </CellTextBoxDot>
          <CellTextBoxDot style={narrowCellsFrench}>
            {safeZero(row, "turnoversTeam")}
          </CellTextBoxDot>
          <CellTextBoxDot
            style={{ ...narrowCellsFrench, width: "19mm", borderRightWidth: 1 }}
          >
            {" "}
          </CellTextBoxDot>
        </React.Fragment>
      ) : (
        <React.Fragment>
          {!isTotalsRow && (
            <React.Fragment>
              <CellTextBoxDot noDot={true} style={{ width: "5mm" }}>
                {row.bib ?? " "}
              </CellTextBoxDot>
              <CellTextBoxDot
                style={{
                  textAlign: "left",
                  paddingLeft: 2,
                  width: "31.8mm",
                  borderLeftWidth: 0,
                }}
              >
                {`${safeString(row, "personFullName")}${
                  persons[row.personId]?.captain
                    ? ` ${intl.formatMessage({
                        id: "reports.boxscore.table.captain",
                        defaultMessage: "(C)",
                      })}`
                    : ""
                }`}
              </CellTextBoxDot>
              <CellTextBoxDot style={{ width: "4mm" }} noDot={true}>
                {row.starter ? "#" : ""}
              </CellTextBoxDot>
            </React.Fragment>
          )}
          {isTotalsRow && (
            <React.Fragment>
              <CellTextBoxDot style={{ width: "5mm" }}> </CellTextBoxDot>
              <CellTextBoxDot
                style={{
                  textAlign: "right",
                  paddingRight: 15,
                  width: "31.8mm",
                  fontWeight: "bold",
                  borderLeftWidth: 0,
                }}
              >
                {intl.formatMessage({
                  id: "reports.boxscore.table.totals",
                  defaultMessage: "Totals",
                })}
              </CellTextBoxDot>
              <CellTextBoxDot
                style={{ width: "13mm", textAlign: "right", paddingRight: 2 }}
              >
                {rowMinutesText}
              </CellTextBoxDot>
            </React.Fragment>
          )}
          {!isTotalsRow && (
            <CellTextBoxDot style={{ width: "9mm" }}>
              {rowMinutesText}
            </CellTextBoxDot>
          )}
          <CellTextBoxDot noDot={true} style={{ width: "6mm" }}>
            {safeZero(row, "points")}
          </CellTextBoxDot>
          <CellTextBoxDot style={{ width: "8mm" }}>
            {safeZero(row, "fieldGoalsMade") +
              "/" +
              safeZero(row, "fieldGoalsAttempted")}
          </CellTextBoxDot>
          <CellTextBoxDot style={{ width: "8mm" }}>
            {
              <NumberAsPercent
                useDot={true}
                percentValue={safeZero(row, "fieldGoalsPercentage")}
                fractionDigits={0}
              />
            }
          </CellTextBoxDot>
          <CellTextBoxDot style={{ width: "8mm" }}>
            {safeZero(row, "pointsThreeMade") +
              "/" +
              safeZero(row, "pointsThreeAttempted")}
          </CellTextBoxDot>
          <CellTextBoxDot style={{ width: "8mm" }}>
            {
              <NumberAsPercent
                useDot={true}
                percentValue={safeZero(row, "pointsThreePercentage")}
                fractionDigits={0}
              />
            }
          </CellTextBoxDot>
          <CellTextBoxDot style={{ width: "8mm" }}>
            {row.pointsTwoAttempted - row.pointsInThePaintAttempted
              ? row.pointsTwoMade -
                row.pointsInThePaintMade +
                "/" +
                (row.pointsTwoAttempted - row.pointsInThePaintAttempted)
              : "."}
          </CellTextBoxDot>
          <CellTextBoxDot style={{ width: "8mm" }}>
            {row.pointsTwoAttempted - row.pointsInThePaintAttempted
              ? (
                  (100 * (row.pointsTwoMade - row.pointsInThePaintMade)) /
                  (row.pointsTwoAttempted - row.pointsInThePaintAttempted)
                ).toFixed(0)
              : "."}
          </CellTextBoxDot>
          <CellTextBoxDot style={{ width: "8mm" }}>
            {safeZero(row, "pointsInThePaintMade") +
              "/" +
              safeZero(row, "pointsInThePaintAttempted")}
          </CellTextBoxDot>
          <CellTextBoxDot style={{ width: "8mm" }}>
            {row.pointsInThePaintAttempted
              ? (
                  (100 * row.pointsInThePaintMade) /
                  row.pointsInThePaintAttempted
                ).toFixed(0)
              : "."}
          </CellTextBoxDot>

          <CellTextBoxDot style={{ width: "6mm" }}>
            {safeZero(row, "dunks")}
          </CellTextBoxDot>
          <CellTextBoxDot style={{ width: "8mm" }}>
            {safeZero(row, "freeThrowsMade") +
              "/" +
              safeZero(row, "freeThrowsAttempted")}
          </CellTextBoxDot>
          <CellTextBoxDot style={{ width: "8mm" }}>
            {
              <NumberAsPercent
                useDot={true}
                percentValue={safeZero(row, "freeThrowsPercentage")}
                fractionDigits={0}
              />
            }
          </CellTextBoxDot>

          <CellTextBoxDot style={{ ...narrowCellsFrench }}>
            {teamOrCoachRow
              ? parseInt(safeZero(row, "foulsTotal"), 10) +
                parseInt(safeZero(teamOrCoachRow, "fouls"), 10)
              : safeZero(row, "foulsTotal")}
          </CellTextBoxDot>
          <CellTextBoxDot style={narrowCellsFrench}>
            {safeZero(row, "foulsDrawn")}
          </CellTextBoxDot>
          <CellTextBoxDot style={narrowCellsFrench}>
            {safeZero(row, "blocks")}
          </CellTextBoxDot>
          <CellTextBoxDot style={narrowCellsFrench}>
            {safeZero(row, "blocksReceived")}
          </CellTextBoxDot>

          <CellTextBoxDot style={{ ...narrowCellsFrench }}>
            {safeZero(row, "reboundsOffensive")}
          </CellTextBoxDot>
          <CellTextBoxDot style={{ ...narrowCellsFrench }}>
            {safeZero(row, "reboundsDefensive")}
          </CellTextBoxDot>
          <CellTextBoxDot style={narrowCellsFrench}>
            {safeZero(row, "rebounds")}
          </CellTextBoxDot>

          <CellTextBoxDot style={{ ...narrowCellsFrench }}>
            {safeZero(row, "steals")}
          </CellTextBoxDot>
          <CellTextBoxDot style={narrowCellsFrench}>
            {safeZero(row, "turnovers")}
          </CellTextBoxDot>
          <CellTextBoxDot style={narrowCellsFrench}>
            {safeZero(row, "assists")}
          </CellTextBoxDot>

          <CellTextBoxDot style={{ width: "7mm" }}>
            {safeZero(row, "efficiency")}
          </CellTextBoxDot>
          <CellTextBoxDot style={{ ...narrowCellsFrench, borderRightWidth: 1 }}>
            {safeZero(row, "plusMinus")}
          </CellTextBoxDot>
        </React.Fragment>
      )}
    </View>
  );
};
